import { createContext } from 'react'

type Context = {}

export const UserContext = createContext<Context>(null)
